import { syncResponse } from '~/types';

type SyncResultListener = (result: syncResponse) => void;

const listeners = new Set<SyncResultListener>();

export function subscribeSyncResults(listener: SyncResultListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function publishSyncResult(result: syncResponse | void): void {
  if (!result) {
    return;
  }
  const hasIssueIds = result.issueIds && result.issueIds.length > 0;
  const hasUpdates =
    result.updatedIssuesDetails && result.updatedIssuesDetails.length > 0;
  if (!hasIssueIds && !hasUpdates) {
    return;
  }
  listeners.forEach((listener) => listener(result));
}
